function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vertical_switch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M2.5 16L6.5 20M6.5 20L10.5 16M6.5 20L6.5 6C6.5 4.89543 7.39543 4 8.5 4V4",
    stroke: "#3D3D7E",
    style: {
      stroke: "#3D3D7E",
      stroke: "color(display-p3 0.2392 0.2392 0.4941)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M13.5 8L17.5 4M17.5 4L21.5 8M17.5 4L17.5 19C17.5 20.1046 16.6046 21 15.5 21V21",
    stroke: "#3D3D7E",
    style: {
      stroke: "#3D3D7E",
      stroke: "color(display-p3 0.2392 0.2392 0.4941)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.706fb4137be953745e051ec1d9000956.svg";
export { ForwardRef as ReactComponent };